import { getClientDisplayName } from '../model/displayName';
import type { ClientResponse } from '@/core/generated/api';
import { PersonOption } from '@/shared/ui/PersonOption/PersonOption';


/** Показывает клиента с питомцами и контактами */
export const ClientOptionRow = (
    { client, selected }: { client: ClientResponse; selected?: boolean }
) => (
    <PersonOption
        name={getClientDisplayName(client)}
        phone={client.phone || client.appUserPhone}
        photoUrl={client.photoUrl}
        details={[client.cityName?.trim(), client.email?.trim()].filter(Boolean).join(' · ')}
        blocked={client.isBlocked}
        selected={selected}
    />
);
